module.exports = __webpack_public_path__ + "img/icon-user.54404adc.svg";